<template>
	  <div class="profile" v-if="Object.keys(selectedUser).length !== 0">
      <!-- display user image -->
      <div class="profile__img">
        <!-- display google image if auth user -->
      <img v-if="authUser.email == selectedUser.gmailAcc" :src="authUser.photoURL">
      <img v-else :src="selectedUser.image"> 
      <br>
      </div>
      <div class="profile__user-info">
        <!-- display user name -->
        <h1 v-if="authUser.email == selectedUser.gmailAcc">
          {{authUser.displayName }}
        </h1>
        <h1 v-else> 
          {{ selectedUser.fName }} 
          {{ selectedUser.lName }}
        </h1> 
        <!-- display desk location -->
        <div>
          <ul>
            <li v-if="selectedUser.deskref">{{ selectedUser.deskref.acronym }}</li>
            <li>{{ selectedUser.division }}</li>
            <li v-if="selectedUser.deskref">{{ selectedUser.deskref.building }} {{ selectedUser.deskref.level }}</li>
            <li v-else>Not checked in.</li>
          </ul>
        </div> 

        <!-- display jobtitle and team info  -->
        <h2>
          {{ selectedUser.jobTitle }}
          <br>
          Team {{ selectedUser.team}}
        </h2>
      </div>
      <div class="profile__line-separator"></div>
      <!-- display user contact info -->
      <table class="profile__user-contact">
        <tr>
          <td><img src="../../static/images/mail-icon.png"></td>
          <td><a :href="`mailto:${selectedUser.gmailAcc}`">{{ selectedUser.gmailAcc }}</a></td> 
        </tr>
        <tr>
          <td><img id="mobile-icon" src="../../static/images/mobile-icon.png"></td>
          <td><a :href="`tel:${selectedUser.mobile}`">{{ selectedUser.mobile }}</a></td> 
        </tr>
        <tr>
          <td><img src="../../static/images/phone-icon.png"></td>
          <td><a :href="`tel:${selectedUser.landline}`">{{ selectedUser.landline }}</a></td> 
        </tr>
      </table>
      <!-- flexible container to adjust height -->
      <div class="profile__flex-container"></div>
      <!-- display deep link icons -->
      <div class="profile__user-deep-links">
        <a :href="selectedUser.wiki" target="_blank"><img id="wiki-icon" src="../../static/images/wikipedia.png"></a>
        <a :href="selectedUser.googleCal" target="_blank"><img src="../../static/images/ic-date-range-black-24.png"></a>
        <a :href="selectedUser.slack" target="_blank"><img src="../../static/images/slack-mark-monochrome-black.png" target="_blank"></a>
        <a :href="selectedUser.skillWill" target="_blank"><img src="../../static/images/skillwill.png"></a>

      </div>
  </div>

</template>

<script>

import { mapState } from 'vuex';

export default {


  name: "Profile",
  props: {
    selectedUser: Object
  },
  computed: {
    ...mapState({authUser: state => state.authUser})
  }

}

</script>

<style lang="css">

@import "../../styles/css/profile.component.css"

</style>


// WEBPACK FOOTER //
// src/components/Profile.vue